<template>
  <div class="">
    <table-items :active-table-field="tableItemsActiveField" :items="items" :restoreState="false"/>

    <div class="row text-center pt-3">
      <div class="mt-3 ml-auto mr-auto color">
        <pagination :meta="paginationMeta" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import TableLayout from "../../dashboard/TableLayout";
import Pagination from "../../dashboard/Pagination";
import tableItems from "../../dashboard/orders/tableItems.vue";

export default {
  name: "subscriptionUserOrders",
  components: {TableLayout, Pagination, tableItems},
  data() {
    return {
      tableItemsActiveField: ['table-field-order-price', 'table-field-order-payment-status', 'table-field-order-updated-at', 'table-field-order-payment-date', 'table-field-order-actions', 'table-field-order-items'],
      items: [],
      paginationMeta: {},
      form: {
        page: 1,
        user_id: null
      }
    }
  },
  computed: {
    ...mapGetters({
      userId: "User/getUserId",
      isAdmin: "User/isAdmin"
    }),
    userIdComputed() {
      let userId = this.userId;

      let routeName = this.$route.name
      if (routeName !== 'UserSubscription') {
        userId = this.$route.params.user
      }
      return userId
    }
  },
  methods: {
    async getItem(page = 1) {
      this.form.page = page
      this.form.user_id = this.userIdComputed
      let data = await this.$store.dispatch("ShoppingCart/getUserOrdersWithoutState", this.form);
      data = data.data.data

      this.items = data.data
      this.paginationMeta = data.meta

    },
    changePage(page) {
      this.getItem(page)
    },
  },
  mounted() {
    this.getItem();
  }
};
</script>
<style scoped>
.order-background {
  background: #f3f3f3;
}
</style>